import { render } from "./ModalPorts.vue?vue&type=template&id=4717d0ea"
import script from "./ModalPorts.vue?vue&type=script&lang=js"
export * from "./ModalPorts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__